var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"timer",style:(_vm.timerStyle)},[_vm._v(_vm._s(`${_vm.remaining ? '-' : ''}${_vm.toHumanTime(_vm.time)}`))])
}
var staticRenderFns = []

export { render, staticRenderFns }